import { InstagramAccount } from 'apps/instagram/models/interfaces'
import { ResponseInstagramAccount } from 'shared/api/requests/settings/schemas'

export const parseAccounts = (accounts: ResponseInstagramAccount[]): InstagramAccount[] =>
  accounts.map((data) => ({
    userName: data.username,
    id: String(data.id),
    profilePicture: data.profile_picture ?? '',
    followersCount: data.followers_count,
  }))
